<template>
  <v-container class="ml-1">
    <v-card-title class="pa-0 mb-1">{{ $t('dashboard.propertyTickets.title') }}</v-card-title>
    <v-data-table
      :class="tableClassName"
      :headers="headers"
      :items="searchTicketingTicketsItems"
      :item-class="rowClass"
      :loading="$apollo.loading"
      :footer-props="{itemsPerPageOptions: itemsPerPageOptions, itemsPerPageText: itemsPerPageText}"
      :server-items-length="searchTicketingTicketsTotalItems"
      :options.sync="options"
      @click:row="processInstanceSelected"
      class="elevation-1"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template v-slot:[`item.processInfo`]="{ item }">
        <p class="truncate-two-lines">
          {{ item.processDefinitionName }}<template v-if="item.subject"> - {{ item.subject }}</template>
        </p>
      </template>
      <template v-slot:[`item.state`]="{ item }">
        <StateIcon :state="item.state" />
      </template>
      <template v-slot:[`item.dateInfo`]="{ item }">
        <div>{{ formatDateAndTimeFunc(item.startedOn) }}</div>
        <div>{{ formatDateAndTimeFunc(item.finishedOn) }}</div>
      </template>
      <template slot="no-data">
        <v-alert class="mt-4" :value="true" color="error" icon="warning">
          {{ $t('table.noData') }}
        </v-alert>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import StateIcon from '@/components/StateIcon'
import { setRowClassByDiff } from '@/helpers/momentHelper'
import { formatDateAndTime } from '@/helpers/formatterHelper'
import { SEARCH_PROPERTY_TICKETING_TICKETS } from './graphql-apollo/searchTicketingTickets.gql'

export default {
  name: 'PropertyTicketList',
  data () {
    return {
      tableClassName: 'propertyTicketList',
      options: { itemsPerPage: 10, page: 1 },
      itemsPerPageOptions: [10, 15, 25]
    }
  },
  apollo: {
    searchTicketingTickets: {
      query: SEARCH_PROPERTY_TICKETING_TICKETS,
      variables () {
        return {
          query: {
            processDefinitionKey: 'Z1_01',
            propertyIds: this.propertyIds,
            orderBy: 'STARTED_ON',
            orderByDirection: 'DESC',
            page: this.options.page - 1,
            size: this.options.itemsPerPage
          }
        }
      },
      skip () {
        return !this.propertyIds || this.propertyIds.length === 0
      }
    }
  },
  components: {
    StateIcon
  },
  props: {
    properties: {
      type: Array,
      default: () => []
    },
    processInstanceCreated: {
      type: Number,
      default: 0
    }
  },
  watch: {
    processInstanceCreated () {
      if (!this.$apollo.loading) {
        this.$apollo.queries.searchTicketingTickets.refresh()
      }
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('ticketingSystem.processes.process'),
          align: 'left',
          value: 'processInfo',
          sortable: false
        },
        {
          text: this.$t('ticketingSystem.taskDetails.state'),
          align: 'left',
          value: 'state',
          sortable: false
        },
        {
          text: this.dateHeader,
          align: 'left',
          value: 'dateInfo',
          sortable: false
        }
      ]
    },
    itemsPerPageText () {
      return this.$t('common.itemsPerPageText')
    },
    propertyIds () {
      return this.properties?.map(property => property?.propertyId?.toString())
    },
    searchTicketingTicketsItems () {
      return this.searchTicketingTickets ? this.searchTicketingTickets.items : []
    },
    searchTicketingTicketsTotalItems () {
      return this.searchTicketingTickets ? this.searchTicketingTickets.totalItems : 0
    },
    dateHeader () {
      return this.$t('ticketingSystem.taskDetails.processReferences.startedOn') + ' / ' + this.$t('ticketingSystem.taskDetails.processReferences.finishedOn')
    }
  },
  methods: {
    formatDateAndTimeFunc: formatDateAndTime,
    rowClass (item) {
      let className = 'row-' + item.processInstanceId + ' '
      className += setRowClassByDiff(item.startedOn)
      return className
    },
    processInstanceSelected (value) {
      window.open('/ticketing/processes/' + value.ticketId)
    }
  }
}
</script>

<style scoped lang="postcss">
/deep/ tr:nth-child(odd) {
  background: #f8f8f8;
}
/deep/ tr {
  cursor: pointer;
}
.truncate-two-lines {
  max-height: 39px;
  display: -webkit-inline-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  margin: 0 auto;
  line-height: 1.5;
}
</style>
